import { createContext } from 'react';
var LangContext = createContext({});
export default LangContext;
//# sourceMappingURL=LangContext.js.mapimport { createContext } from 'react';
var LangContext = createContext({});
export default LangContext;
//# sourceMappingURL=LangContext.js.map